import RibbonButton, { RibbonButtonState } from './RibbonButton';
import strings from 'owa-strings/owa-mail-strings';
import { removeLink } from 'roosterjs-editor-api';

const unlink: RibbonButton = {
    key: 'unlink',
    title: () => strings.unlink,
    imageSrc: require('../svg/unlink.svg'),
    buttonState: formatState =>
        formatState.canUnlink ? RibbonButtonState.Normal : RibbonButtonState.Disabled,
    onExecute: plugin => removeLink(plugin.getEditor()),
};

export default unlink;
